import { ReactNode, createContext } from "react";
import useContaFinanceira, { ContaFinanceiraType, CreateContaFinanceiraType, UpdateContaFinanceiraType} from "./hooks/useContaFinanceira";

interface ContaFinanceiraContextProviderProps {
    children: ReactNode;
}

export interface ContaFinanceiraContextData {
    getAllContaFinanceiraPaged: (
        pageNumber: number,
        pageSize: number,
        empresaId?: number,
    ) => Promise<ContaFinanceiraType[] | null>;
    setContaFinanceira: any;
    contaFinanceira: ContaFinanceiraType;
    setListContaFinanceira: any;
    listContaFinanceira: ContaFinanceiraType[];
    setInitialListContaFinanceira: any;
    initialListContaFinanceira: ContaFinanceiraType[];
    setContaFinanceiraPageCount: any;
    contaFinanceiraPageCount: number;
    createContaFinanceira: (createContaFinanceiraType: CreateContaFinanceiraType) => Promise<CreateContaFinanceiraType | null>;
    updateContaFinanceira: (updateContaFinanceiraType: UpdateContaFinanceiraType) => Promise<UpdateContaFinanceiraType | null>;
    deleteContaFinanceira: (id: number) => Promise<ContaFinanceiraType | null>;
    handleGetContaFinanceiraByEmpresaId: (empresaId: number) => Promise<ContaFinanceiraType[] | null>;
    listContaFinanceiraByEmpresa: ContaFinanceiraType[];
    setListContaFinanceiraByEmpresa: any;
}

const initialState: ContaFinanceiraContextData = {
    getAllContaFinanceiraPaged: async (
        pageNumber: number,
        pageSize: number,
        officeId?: number,
    ) => {
        return Promise.resolve(null);
    },
    setContaFinanceira: () => { },
    contaFinanceira: {
        id: 0,
        name: "",
        openingBalance: 0,
        empresaId: 0,
    },
    setListContaFinanceira: () => {},
    listContaFinanceira: [],
    setInitialListContaFinanceira: () => {},
    initialListContaFinanceira: [],
    setContaFinanceiraPageCount: () => {},
    contaFinanceiraPageCount: 0,
    createContaFinanceira: async (createContaFinanceiraType: CreateContaFinanceiraType) => {
        return Promise.resolve(null);
    },
    updateContaFinanceira: async (updateContaFinanceiraType: UpdateContaFinanceiraType) => {
        return Promise.resolve(null);
    },
    deleteContaFinanceira: async (id: number) => {
        return Promise.resolve(null);
    },
    handleGetContaFinanceiraByEmpresaId: async (empresaId: number) => {
        return Promise.resolve(null);
    },
    listContaFinanceiraByEmpresa: [],
    setListContaFinanceiraByEmpresa: () => {},
};

export const ContaFinanceiraContext =
    createContext<ContaFinanceiraContextData>(initialState);

export default function ContaFinanceiraContextProvider({
    children,
}: ContaFinanceiraContextProviderProps) {
    const {
        getAllContaFinanceiraPaged,
        createContaFinanceira,
        updateContaFinanceira,
        deleteContaFinanceira,
        contaFinanceira,
        setContaFinanceira,
        setListContaFinanceira,
        listContaFinanceira,
        initialListContaFinanceira,
        setInitialListContaFinanceira,
        setContaFinanceiraPageCount,
        contaFinanceiraPageCount,
        handleGetContaFinanceiraByEmpresaId,
        listContaFinanceiraByEmpresa,
        setListContaFinanceiraByEmpresa,
    } = useContaFinanceira();

    return (
        <ContaFinanceiraContext.Provider
            value={{
                getAllContaFinanceiraPaged,
                createContaFinanceira,
                updateContaFinanceira,
                deleteContaFinanceira,
                contaFinanceira,
                setContaFinanceira,
                setListContaFinanceira,
                listContaFinanceira,
                initialListContaFinanceira,
                setInitialListContaFinanceira,
                setContaFinanceiraPageCount,
                contaFinanceiraPageCount,
                handleGetContaFinanceiraByEmpresaId,
                listContaFinanceiraByEmpresa,
                setListContaFinanceiraByEmpresa,
            }}
        >
            {children}
        </ContaFinanceiraContext.Provider>
    );
}